import React from "react";
import { StyledBlockPadded } from "../../SharedStyledComponents";

const EbolaRiskList = () => (
  <StyledBlockPadded>
    <p>Countries with the highest relative risk of Ebola spread</p>
    <ol>
      <li>Guinea</li>
      <li>Nigeria</li>
      <li>Ivory Coast</li>
      <li>Sierra Leone</li>
      <li>Mali</li>
      <li>Liberia</li>
      <li>Senegal</li>
      <li>Ghana</li>
      <li>Burkina Faso</li>
      <li>Democratic Republic of the Congo</li>
    </ol>
  </StyledBlockPadded>
);

export default EbolaRiskList;
